import React, { useEffect } from 'react';
import { reduxConnect } from '../../common';
import { PageContentContainer } from '../common/subnavigation/pageContentContainer';
import { NewsVideosPageSubNavigation } from './newsVideosPageSubNavigation';
import { DisplayNewsVideosPageUI } from './displayNewsVideosPageUI';

interface NewsVideosPageContainerViewProps {
    activePageId: string;
    Metadata: any;
}

const mapStoreStateToProps = (storeState: any) => {
    const { pageId } = storeState?.appState?.appState || {};

    return {
        activePageId: pageId
    };
};

const mapDispatchToProps = {};

export const NewsVideosPageContainerView = reduxConnect(mapStoreStateToProps, mapDispatchToProps)((
    {
        activePageId,
        Metadata
    }: NewsVideosPageContainerViewProps) => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [activePageId]);

    return (
        <PageContentContainer>
            <NewsVideosPageSubNavigation />
            <DisplayNewsVideosPageUI Metadata={Metadata} />
        </PageContentContainer>
    );
});

NewsVideosPageContainerView.displayName = 'NewsVideosPageContainerView';
